export const showTotal = (total: number, range: [number, number]) => {
  return `Displayed ${range[0]}-${range[1]} из ${total}`;
};
